import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const PlotIcon2 = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 27 22" fill="none" {...props}>
    <path
      d="M7.07309 13.1631C7.20882 13.4276 7.42537 13.6432 7.69218 13.7781C7.99525 13.9314 8.39209 13.9314 9.18525 13.9314H17.4018C18.195 13.9314 18.5918 13.9314 18.8949 13.7781C19.1612 13.6432 19.3783 13.4281 19.514 13.1631C19.6684 12.862 19.6684 12.4678 19.6684 11.6798V6.58888C19.6684 6.18487 19.6684 5.98261 19.6161 5.79631C19.5694 5.63162 19.4933 5.47619 19.3907 5.33878C19.2752 5.18336 19.1146 5.05932 18.7934 4.81126L13.9893 1.09958C13.7406 0.907098 13.6163 0.811372 13.4785 0.774317C13.3573 0.741894 13.2298 0.741894 13.1086 0.774317C12.9713 0.811372 12.847 0.907613 12.5978 1.09958L7.79372 4.81126C7.47252 5.05932 7.31192 5.18336 7.19639 5.33878C7.09381 5.47619 7.01765 5.63162 6.97103 5.79631C6.9187 5.98261 6.9187 6.18436 6.9187 6.58888V11.6798C6.9187 12.4678 6.9187 12.862 7.07309 13.1631Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      fill="none"
    />

    <path
      d="M6.91865 12.4471C6.57206 12.4327 6.0571 12.4445 5.51934 12.4471C5.40174 12.4476 5.20954 12.4635 4.99402 12.5536C4.74017 12.6596 4.57853 12.8166 4.49668 12.9087C3.27714 14.483 2.05812 16.0574 0.83859 17.6317C0.786265 17.6832 0.75 17.7629 0.75 17.8576V20.2878C0.75 20.4438 0.843252 20.5709 0.958264 20.5714C9.18106 20.6311 17.4044 20.6903 25.6277 20.75C25.7437 20.751 25.838 20.6234 25.838 20.4664V17.8576C25.838 17.7007 25.7442 17.5741 25.6287 17.5741H0.958782C0.931324 17.5741 0.905421 17.5823 0.881589 17.5952"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      fill="none"
    />

    <path
      d="M19.6682 12.3622C20.0148 12.3478 20.5298 12.3596 21.0675 12.3622C21.1851 12.3627 21.3773 12.3786 21.5928 12.4687C21.8467 12.5747 22.0083 12.7317 22.0902 12.8238C23.3097 14.3981 24.5287 15.9725 25.7483 17.5468"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      fill="none"
    />
  </SvgIcon>
);
